export const headLang = {
    staking: {
        'en': '$ARTY Staking',
        'fr': 'Staking $ARTY',
        'de': '$ARTY-Staking',
        'ko': '$ARTY 스테이킹',
        'ch': '$ARTY 质押',
        'ru': 'Стейкинг $ARTY',
        'it': 'STAKING $ARTY',
        'jap': '$ARTYコインを賭ける',
        'port': 'STAKE $ARTY ',
        'turk': '$ARTY HİSSESİ ALMA',
        'viet': 'STAKE ARTY$',
        'spa': 'STAKING $ARTY',
        'arab': 'تخزين $ARTY'
    },
}